import { ThemeMode } from 'config'
import PropTypes from 'prop-types'

// ==============================|| PRESET THEME - DEFAULT ||============================== //

const Default = (colors, mode) => {
  const greyColors =
    mode === ThemeMode.DARK
      ? {
          0: '#111111',
          100: '#0D0F12',
          200: '#171A1F',
          300: '#1E2229',
          400: '#323741',
          500: '#4A5663',
          600: '#98A1B3',
          700: '#D2D7DF',
          800: '#F0F0F0',
          900: '#F5F5F5',
          A100: '#FFFFFF',
        }
      : {
          // lighter: greyColors[0],
          // light: greyColors[100],
          // main: greyColors[200],
          // dark: greyColors[300],
          // darker: greyColors[400],
          0: '#FFFFFF',
          100: '#F0F0F0',
          200: '#F5F5F5',
          300: '#FFFFFF',
          400: '#D2D7DF',
          500: '#98A1B3',
          600: '#98A1B3',
          700: '#4A5663',
          800: '#1B1D21',
          900: '#131417',
          A100: '#111111',
        }

  // const greyColors =
  //   mode === ThemeMode.DARK
  //     ? {
  //         0: '#ODOF12',
  //         100: '#171A1F',
  //         200: '#1E2229',
  //         300: '#323741',
  //         400: '#4A5663',
  //         500: '#98A1B3',
  //         600: '#D2D7DF',
  //         700: '#F0F0F0',
  //         800: '#F5F5F5',
  //         900: '#FFFFFF',
  //         A100: '#FFFFFF',
  //       }
  //     : {
  //         0: '#F0F0F0',
  //         100: '#F5F5F5',
  //         200: '#FFFFFF',
  //         300: '#D2D7DF',
  //         400: '#98A1B3',
  //         500: '#494F5A',
  //         600: '#323437',
  //         700: '#292929',
  //         800: '#1B1D21',
  //         900: '#131417',
  //         A100: '#111111',
  //       }

  const brandColors =
    mode === ThemeMode.DARK
      ? {
          300: '#0F606B',
          400: '#12707D',
          500: '#14818F',
          600: '#1DB9CD',
          700: '#98E6F0',
        }
      : {
          300: '#98E6F0',
          400: '#1DB9CD',
          500: '#14818F',
          600: '#12707D',
          700: '#0F606B',
        }

  const redColors =
    mode === ThemeMode.DARK
      ? {
          100: '#FFE3E0',
          300: '#FF6C5C',
          600: '#C1390B',
          700: '#822608',
          800: '#470700',
        }
      : {
          100: '#822608',
          300: '#C1390B',
          600: '#FFE3E0',
        }

  const greenColors =
    mode === ThemeMode.DARK
      ? {
          100: '#F1F9F1',
          200: '#BEE7B6',
          300: '#8ACB88',
          600: '#3A822B',
          700: '#27581D',
        }
      : {
          100: '#27581D',
          300: '#C1390B',
          600: '#BEE7B6',
        }

  const blueColors =
    mode === ThemeMode.DARK
      ? {
          300: '#6DC0F8',
          400: '#4392E8',
          500: '#1A75D6',
          600: '#1A75D6',
          700: '#0D3969',
        }
      : {
          300: '#13579F',
          400: '#4392E8',
          500: '#1A75D6',
          600: '#6DC0F8',
          700: '#0D3969',
        }

  const purpleColors =
    mode === ThemeMode.DARK
      ? {
          300: '#553CB9',
          400: '#8C5383',
          500: '#704269',
          600: '#AB8EDB',
          700: '#E3C9F8',
        }
      : {
          300: '#E3C9F8',
          400: '#AB8EDB',
          500: '#704269',
          600: '#8C5383',
          700: '#553CB9',
        }

  const pinkColors =
    mode === ThemeMode.DARK
      ? {
          300: '#A63573',
          400: '#AA6FA1',
          500: '#DD94BC',
          600: '#FFD3DB',
        }
      : {
          300: '#FFD3DB',
          400: '#DD94BC',
          500: '#AA6FA1',
          600: '#A63573',
        }

  const yellowColors =
    mode === ThemeMode.DARK
      ? {
          200: '#FEF2BB',
          300: '#FDE695',
          400: '#FDD870',
          500: '#FDC74D',
          600: '#F8B131',
          700: '#D28A24',
          800: '#AB6B18',
        }
      : {
          300: '#AB6B18',
          400: '#F1C09D',
          500: '#D28A24',
          600: '#6D700A',
          700: '#F8B131',
          800: '#752B0B',
        }

  const contrastText = '#000000'

  return {
    primary: {
      lighter: brandColors[300],
      light: brandColors[400],
      main: brandColors[500],
      dark: brandColors[600],
      darker: brandColors[700],
      contrastText,
    },
    secondary: {
      lighter: greyColors[100],
      light: greyColors[200],
      main: greyColors[300],
      dark: greyColors[400],
      darker: greyColors[500],
    },
    error: {
      light: redColors[100],
      main: redColors[300],
      dark: redColors[600],
      darker: redColors[600],
    },
    warning: {
      light: yellowColors[300],
      main: yellowColors[500],
      dark: yellowColors[700],
    },
    info: {
      light: blueColors[300],
      main: blueColors[400],
      dark: blueColors[700],
    },
    success: {
      lighter: greenColors[100],
      light: greenColors[100],
      main: greenColors[300],
      dark: greenColors[300],
      darker: greenColors[600],
    },
    status: {
      onHold: yellowColors[300],
      needsRefresh: '#F8912E',
    },

    grey: greyColors,
    blue: blueColors,
    brand: brandColors,
    pink: pinkColors,
    spacing: (factor) => `${0.25 * factor}rem`,

    charts: {
      400: mode === ThemeMode.DARK ? blueColors[300] : blueColors[500], // 1      #6DC0F8
      light: blueColors[400], // 2    #4392E8
      dark: pinkColors[500], // 3     #DD94BC
      darker: purpleColors[600], // 4 #FFD3DB
      main: brandColors[700], // 5    #98E6F0
      200: brandColors[400], // 6     #1DB9CD
      lighter: brandColors[500], // 7 #14818F
      800: purpleColors[600], // 8    #AB8EDB
      A200: mode === ThemeMode.DARK ? purpleColors[700] : purpleColors[500], // 9     #E3C9F8
      A300: yellowColors[300], // 10  #FDE695
      A100: yellowColors[400], // 11  #FDD870
      600: mode === ThemeMode.DARK ? yellowColors[400] : yellowColors[500], // 12   #FDC74D
      A400: greyColors[600], // 13    #494F5A
      small1: yellowColors[200],
    },
    kak: {
      longShortPositions: ['#A4E2A2', '#FF6C5C'],
      historyVar: {
        95: '#33A8F6',
        975: '#AB8EDB',
        99: '#D37E41',
      },
    },
    transactions: {
      side: {
        buy: greenColors[300],
        sell: redColors[300],
      },
    },
  }
}

Default.propTypes = {
  colors: PropTypes.object,
}

export default Default
